module.exports = __webpack_public_path__ + "static/media/vn.7e156d1d.svg";